import { jwtDecode } from "jwt-decode";
export const getToken = () => localStorage.getItem("token");

export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const { exp } = jwtDecode(token);
    const now = Date.now() / 1000; // in seconds
    return exp < now;
  } catch (err) {
    return true;
  }
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  window.location.href = "/signin";
};
